import { render, staticRenderFns } from "./admin-catastro.vue?vue&type=template&id=43cd80e6&scoped=true&"
import script from "./admin-catastro.vue?vue&type=script&lang=js&"
export * from "./admin-catastro.vue?vue&type=script&lang=js&"
import style0 from "./admin-catastro.vue?vue&type=style&index=0&id=43cd80e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd80e6",
  null
  
)

export default component.exports